import {IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {ICreateFornecedorDto} from "@models/fornecedores/dto/ICreateFornecedorDto.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import _fornecedor_endpoints from "@components/fornecedores/endpoints/_fornecedor_endpoints.ts";
import {IFornecedor} from "@models/fornecedores/fornecedor.ts";
import {useValue} from "@components/shared/hooks/useValue.tsx";

export function useFornecedor() {
    const {Get} = useApi()

    const importar = (data: IDataNoPageDto<ICreateFornecedorDto[]>) => {
        return Get(_fornecedor_endpoints['import-fornecedores'](data))
    }

    const getFornecedorById = (data: { idFornecedor: number }) => {
        return Get(_fornecedor_endpoints['get-fornecedor-by-id'](data))
    }

    const useFornecedorValue = (data?: IFornecedor | number) => {
        return useValue({
            value: data,
            getter: () => getFornecedorById({idFornecedor: typeof data === 'number' ? data : data?.id ?? 0})
        })
    }

    // const getFornecedor = (data: IDataDto<IFornecedoresFilterDto>) => {
    //     return
    // }

    return {
        importFornecedores: importar,
        useFornecedorValue: useFornecedorValue
    }
}